import { CreateApiResponse, FetchApiResponse } from "redux/types";

export enum LifeCycleReduxTypes {
    LIFE_CYCLE_REPORT = "@@auth/LIFE_CYCLE_REPORT",
    LIFE_CYCLE_REPORT_SUCCESS = "@@auth/LIFE_CYCLE_REPORT_SUCCESS",
    LIFE_CYCLE_REPORT_ERROR = "@@auth/LIFE_CYCLE_REPORT_ERROR",

    RESET_LIFE_CYCLE = "@@auth/RESET_LIFE_CYCLE"

}

export type LifeCycleActionDispatch = {
    type: | LifeCycleReduxTypes.LIFE_CYCLE_REPORT
    | LifeCycleReduxTypes.RESET_LIFE_CYCLE;

    payload: any;
}

export type LifeCycleReducerDispatch = {
    type: | LifeCycleReduxTypes.LIFE_CYCLE_REPORT
    | LifeCycleReduxTypes.LIFE_CYCLE_REPORT_SUCCESS
    | LifeCycleReduxTypes.LIFE_CYCLE_REPORT_ERROR
    | LifeCycleReduxTypes.RESET_LIFE_CYCLE
    
    payload: {
        data?: FetchApiResponse<LifeCycle>
        error?: string
    }
}

export type LifeCycle = {
    id: string
    financierId: string,
    userId: string,
    type: string,
    status: number,
    updatedOn: string;
    createdOn: string;
}

export type CreateLifeCycle = {
    programId: string,
    customerId?: string,
    saveReport?: boolean
}

export type CreateLifeCycleRequest = {
    payload: CreateLifeCycle,
    type: string
}

export type CreateLifeCycleReduxState = {
    loading?: boolean,
    data?: CreateApiResponse<LifeCycle>
    error?: string | null
}